<template>
  <svg viewBox="0 0 32 32">
    <circle
      :r="radius"
      cx="16"
      cy="16"
      stroke-width="6"
      stroke-dasharray="100 100"
    />
    <circle
      :r="radius"
      cx="16"
      cy="16"
      stroke-width="6"
      :stroke-dasharray="fill"
    />
  </svg>
</template>

<script>
export default {
  props: {
    fill: {
      type: String,
      default: '56 100',
    },
    radius: {
      type: Number,
      default: 13,
    },
  },
};
</script>

<style lang='scss' scoped>
  svg {
    height: rem-calc(40);
    width: rem-calc(40);
    transform: scale(1, -1) rotate(90deg);

    circle {
      &:first-child {
        fill: none;
        stroke: #247fdb;
      }

      &:last-child{
        fill: none;
        stroke: #D6E5F6;
      }
    }
  }
</style>
